<style lang='less' scoped>
@import '../base.less';
</style>
<template>
  <div>
    <!-- SEARCH -->
    <!--    -->
    <Row>
      <Col span='24'>
        <Card>
          <!-- ADDBUTTON -->
          <div class='margin-bottom-15'>
            <Button type='primary' v-has="'activityManage/activityConfig/add'" @click='preAdd' icon='md-add'>
              {{ $t('add_button') }}
            </Button>
          </div>
          <!-- DATA -->
          <div>
            <Table :loading='listLoading' :columns='columnsList' :data='tableData' border></Table>
          </div>
          <!-- PAGE -->
          <div class='margin-top-15' style='text-align: center'>
            <Page :total='tableShow.listCount' :current='tableShow.currentPage' :page-size='tableShow.pageSize'
                  @on-change='changePage' @on-page-size-change='changeSize'
                  :page-size-opts='[10,20,30,40,50,100,200,300]' show-elevator show-sizer show-total></Page>
          </div>
        </Card>
      </Col>
    </Row>
    <!-- windowAddEdit -->
    <Modal v-model="windowAdd.show" width="668" :styles="{top: '30px'}" @on-visible-change="windowAddCancel">
      <p slot="header" style="color:#2d8cf0">
        <Icon type="md-alert"></Icon>
        <span>{{ windowAddItem.id ? $t('编辑') : $t('新增') +' 多语言请添加后再修改' }}</span>
      </p>
      <Form ref="windowAddForm" :rules="windowAddValidate" :model="windowAddItem" :label-width="80"
            label-position="left">

        <FormItem style="margin-bottom:4px" label='活动标题' prop='title' >
          <Input v-model='windowAddItem.title' :placeholder="$t('请输入活动标题')" style='width:350px'></Input>
          <internationality v-if="windowAddItem.id" :keyword="'activity|title'+windowAddItem.id" type='' ></internationality>
        </FormItem>
        <FormItem style="margin-bottom:4px" label='活动分类' prop='activity_type_id'>
          <Select v-model='windowAddItem.activity_type_id' style='width:200px'>
            <Option :value="'0'" :key='0'>{{ $t('不分类') }}</Option>
            <Option :key="key" :value="value.id.toString()"
                    v-for="(value, key) in  windowAdd.windowsParams.activityTypeArray"> {{ value.type_name }}
            </Option>

          </Select>
        </FormItem>
        <FormItem style="margin-bottom:4px" label='公告描述' prop='description'>
          <Input type="textarea" v-model='windowAddItem.description' :placeholder="$t('请输入公告描述')" style='width:400px'></Input>
          <internationality v-if="windowAddItem.id" :keyword="'activity|description'+windowAddItem.id" type='' ></internationality>
        </FormItem>
        <FormItem style="margin-bottom:4px" label='活动图片' prop='pic'>
          <!--          <Input v-model='windowAddItem.pic' :placeholder="$t('请输入活动图片')"></Input>-->
          <div class="demo-upload-list" v-if="windowAddItem['pic']" >
            <img :src="windowAddItem['pic']"  style="max-width: 600px;max-height: 600px">
            <div class="demo-upload-list-cover">
              <Icon type="ios-trash-outline" @click.native="handleImgRemove('pic')"></Icon>
            </div>
          </div>
          <input v-if="windowAddItem['pic']" v-model="windowAddItem['pic']" type="hidden" name="image" >
          <Upload type="drag"
                  :action="uploadUrl"
                  :headers="uploadHeader"
                  v-if="!windowAddItem['pic']"
                  :format="['jpg','jpeg','png','gif']"
                  :max-size="5120"
                  :on-success="handleImgSuccess"
                  :on-format-error="handleImgFormatError"
                  :on-exceeded-size="handleImgMaxSize"
                  style="display: inline-block;width:58px">
            <div style="width: 58px;height:58px;line-height: 58px">
              <Icon type="md-camera" size="20"></Icon>
            </div>
          </Upload>
          <internationality v-if="windowAddItem.id" :keyword="'activity|pic'+windowAddItem.id" type='image' ></internationality>
        </FormItem>
        <FormItem style="margin-bottom:4px" label='参与层级' prop='see_level'>
          <CheckboxGroup style="display: inline-block;"
                         v-model="windowAddItem.see_level">
            <Checkbox :key="key" :label="value.level_number"
                      v-for="(value, key) in windowAdd.windowsParams.levelArray"> {{ value.level_name }}
            </Checkbox>
          </CheckboxGroup>
        </FormItem>
        <FormItem style="margin-bottom:4px" label='活动内容' prop='body'>
          <!--          <Input v-model='windowAddItem.body' :placeholder="$t('请输入活动内容')"></Input>-->
          <div>
            <textarea id="ck-editor" name="ckeditor" rows="10" cols="80"></textarea>
          </div>
          <internationality v-if="windowAddItem.id" :keyword="'activity|body'+windowAddItem.id" type='editor' ></internationality>
        </FormItem>
        <div style="border-bottom: 1px solid dodgerblue;padding-bottom:10px;margin-bottom: 20px"></div>


        <FormItem style="margin-bottom:4px" label='是否过期' prop='is_guoqi'>
          <Select v-model='windowAddItem.is_guoqi' style='width:200px'>
            <Option :value="'0'" :key='0'>{{ $t('长期有效') }}</Option>
            <Option :value="'1'" :key='1'>{{ $t('自动过期') }}</Option>
          </Select>
        </FormItem>
        <FormItem style="margin-bottom:4px" label='活动开始时间' prop='start_time' v-if="windowAddItem.is_guoqi=='1'">
          <!--          <Input v-model='windowAddItem.start_time' :placeholder="$t('请输入活动开始时间')"></Input>-->
          <DatePicker type="datetimerange" :options="timeOptions" :value='windowAddItem.huodongTime'
                      @on-change='timeChange' format="yyyy-MM-dd"
                      :placeholder="$t('选择活动时间')" style="width: 200px">
          </DatePicker>
        </FormItem>


        <div style="border-bottom: 1px solid dodgerblue;padding-bottom:10px;margin-bottom: 20px"></div>
        <FormItem style="margin-bottom:4px" label='是否显示申领按钮' prop='is_can_apply'>
          <Select v-model='windowAddItem.is_can_apply' style='width:200px'>
            <Option :value="'0'" :key='0'>{{ $t('不显示') }}</Option>
            <Option :value="'1'" :key='1'>{{ $t('显示') }}</Option>
          </Select>
        </FormItem>
        <FormItem style="margin-bottom:4px" label='每日申领次数' prop='is_can_infinite_apply'
                  v-if="windowAddItem.is_can_apply=='1'">
          <Select v-model='windowAddItem.is_can_infinite_apply' style='width:200px'>
            <Option :value="'1'" :key='1'>{{ $t('不限次数') }}</Option>
            <Option :value="'0'" :key='0'>{{ $t('每天只能申领一次') }}</Option>
          </Select>
        </FormItem>
        <FormItem style="margin-bottom:4px" label='申领条件' prop='setting_activity_apply_condition_id'
                  v-if="windowAddItem.is_can_apply=='1'&&windowAddItem.is_can_infinite_apply=='0'">
          <Select v-model='windowAddItem.setting_activity_apply_condition_id' style='width:200px'>
            <Option :value="'0'" :key='0'>{{ $t('不限制') }}</Option>
            <Option :key="key" :value="value.id.toString()"
                    v-for="(value, key) in  windowAdd.windowsParams.ActivityApplyConditionArray"> {{ value.name }}
            </Option>
          </Select>
        </FormItem>
        <FormItem style="margin-bottom:4px" label='申领规则' prop='apply_rule'
                  v-if="windowAddItem.is_can_apply=='1'&&windowAddItem.is_can_infinite_apply=='0'&&windowAddItem.setting_activity_apply_condition_id!='0'">
          <Input type="textarea" v-model='windowAddItem.apply_rule'
                 :placeholder="$t('格式如下: 500-600|1,600-700|2%,700|3%   说明:逗号隔开, -为范围  %为百分比 没%为固定值  表示500-600赠送1 600-700赠送1%  700以上赠送3%')"></Input>
        </FormItem>
        <div style="border-bottom: 1px solid dodgerblue;padding-bottom:10px;margin-bottom: 20px"></div>
        <FormItem style="margin-bottom:4px" label='排序' prop='sort'>
          <InputNumber v-model='windowAddItem.sort' :placeholder="$t('请输入排序')"></InputNumber>
        </FormItem>
        <FormItem style="margin-bottom:4px" label='状态' prop='is_lock'>
          <Select v-model='windowAddItem.is_lock' style='width:200px'>
            <Option :value="'0'" :key='0'>{{ $t('正常') }}</Option>
            <Option :value="'1'" :key='1'>{{ $t('隐藏') }}</Option>
          </Select>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="text" @click="windowAddCancel()" class="margin-right-10">{{ $t('取消') }}</Button>
        <Button type="primary" @click="windowAddSubmit" :loading="windowAdd.loading">{{ $t('确定') }}</Button>
      </div>
    </Modal>
    <!--    -->
  </div>
</template>
<script>
import internationality from '@/components/internationality'
import {
  getList,
  add,
  del,
  lock,
  getWindowsParams
} from '@/api/activityManage/activityConfig'
import {
  formattingMonth,
  lastMonthDate
} from '@/libs/time'
import { baseUrl } from '@/libs/api.request'
import CKEDITOR from 'CKEDITOR'
import { getToken } from '@/libs/util'

export default {
  name: 'interface_list',
  components:{
    internationality
  },
  data () {
    return {
      uploadUrlCk: baseUrl + 'Index/uploadCk',
      uploadUrl: baseUrl + 'Index/upload',
      uploadHeader: { 'Api-Auth': getToken() },
      timeOptions: {
        shortcuts: [{
          text: '今天',
          value () {
            let a = new Date(new Date(new Date().toLocaleDateString()).getTime())
            let b = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1)
            return [a, b]
          }
        },
          {
            text: '昨天',
            value () {
              let a = new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 * 1000)
              let b = new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 * 1000 + 24 * 60 *
                60 * 1000 - 1)
              return [a, b]
            }
          },
          {
            text: '一周',
            value () {
              let a = new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 * 1000 * 7)
              let b = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1)
              return [a, b]
            }
          },
          {
            text: '本月',
            value () {
              return formattingMonth()
            }
          },
          {
            text: '上月',
            value () {
              return lastMonthDate()
            }
          },
        ]
      },
      columnsList: [{
        title: this.$t('排序'),
        key: 'sort',
        minWidth: 120,
        align: 'center'
      }, {
        title: this.$t('活动名称'),
        key: 'title',

        minWidth: 120,
        align: 'center'
      }, {
        title: this.$t('活动类型'),
        key: 'activity_type_id_name',

        minWidth: 120,
        align: 'center'
      }, {
        title: this.$t('是否显示'),
        align: 'center',
        minWidth: 100,

        key: 'is_lock',
        render: (h, params) => {
          return h('div', [
            h('span', {
              style: {
                color: params.row.is_lock ? '#ed4014' : '#19be6b',
                borderRadius: '11px',
                border: params.row.is_lock ? '1px solid #ed4014' : '1px solid #19be6b',
                display: 'block',
                height: '25px',
                width: '70%',
                lineHeight: '25px',
                margin: 'auto'
              },
            }, params.row.is_lock ? this.$t('隐藏') : this.$t('正常')),
          ])
        }
      }, {
        title: this.$t('活动时间'),
        align: 'center',
        minWidth: 120,
        render: (h, params) => {
          let vm = this
          return h('div', [h('p', {
            style: {
              textAlign: 'left',
              marginLeft: '5px'
            }
          }, this.$t('活动期限') + ':' + params.row.is_guoqi_name), h('p', {
            style: {
              textAlign: 'left',
              marginLeft: '5px'
            }
          }, this.$t('活动开始时间') + ':' + params.row.start_time), h('p', {
            style: {
              textAlign: 'left',
              marginLeft: '5px'
            }
          }, this.$t('活动结束时间') + ':' + params.row.end_time),])
        }
      }, {
        title: this.$t('详情'),
        align: 'center',
        minWidth: 120,
        render: (h, params) => {
          let vm = this
          return h('div', [h('p', {
            style: {
              textAlign: 'left',
              marginLeft: '5px'
            }
          }, this.$t('操作人') + ':' + params.row.admin_name), h('p', {
            style: {
              textAlign: 'left',
              marginLeft: '5px'
            }
          }, this.$t('添加时间') + ':' + params.row.add_time),])
        }
      }, {
        title: this.$t('操作'),
        align: 'center',
        minWidth: 120,
        render: (h, params) => {
          let vm = this
          return h('div', [h('Button', {
            props: {
              type: 'primary'
            },
            style: {
              margin: '0 5px'
            },
            on: {
              'click': () => {
                let vm = this
                vm.windowAdd.show = true
                vm.windowAddItem.title = params.row.title
                vm.windowAddItem.id = params.row.id
                vm.windowAddItem.description = params.row.description
                vm.windowAddItem.body = params.row.body
                vm.windowAddItem.sort = params.row.sort
                vm.windowAddItem.is_lock = params.row.is_lock.toString()
                vm.windowAddItem.activity_type_id = params.row.activity_type_id.toString()
                vm.windowAddItem.pic = params.row.pic.toString()
                this.editorObj1.setData(params.row.body)
                if (params.row.see_level != null) {
                  vm.windowAddItem.see_level = params.row.see_level.split(',').map(Number)
                }
                vm.windowAddItem.is_guoqi = params.row.is_guoqi.toString()
                vm.windowAddItem.start_time = params.row.start_time
                vm.windowAddItem.end_time = params.row.end_time
                vm.windowAddItem.huodongTime = [params.row.start_time, params.row.end_time]
                vm.windowAddItem.is_can_apply = params.row.is_can_apply.toString()
                vm.windowAddItem.is_can_infinite_apply = params.row.is_can_infinite_apply.toString()
                vm.windowAddItem.setting_activity_apply_condition_id = params.row.setting_activity_apply_condition_id.toString()
                vm.windowAddItem.apply_rule = params.row.apply_rule

              }
            }
          }, this.$t('修改')), h('Poptip', {
            props: {
              confirm: true,
              title: this.$t('确定要修改?'),
              transfer: true
            },
            on: {
              'on-ok': () => {

                lock(params.row.id).then(response => {
                  this.$Message.success(response.data.msg)
                  this.getList()
                })
                params.loading = false

              }
            }
          }, [
            h('Button', {
              style: {
                margin: '0 5px'
              },
              props: {
                type: this.$t('info'),
                placement: 'top',
                loading: params.isDeleting
              }
            }, params.row.is_lock ? this.$t('显示') : this.$t('隐藏'))
          ]), h('Poptip', {
            props: {
              confirm: true,
              title: this.$t('您确定要删除?'),
              transfer: true
            },
            on: {
              'on-ok': () => {

                del(params.row.id).then(response => {
                  this.tableData.splice(params.index, 1)
                  this.$Message.success(response.data.msg)
                })
                params.loading = false

              }
            }
          }, [
            h('Button', {
              style: {
                margin: '0 5px'
              },
              props: {
                type: this.$t('error'),
                placement: 'top',
                loading: params.isDeleting
              }
            }, this.$t('删除'))
          ]),])
        }
      },],
      tableData: [],//用于放LIST数据绑定
      tableShow: { //用于分页
        currentPage: 1,
        pageSize: 10,
        listCount: 0
      },
      searchConf: { searchTime: [], }, // 搜索字段

      buttonShow: { //按钮状态显示
        edit: true,
        del: true,
        changeStatus: true
      },
      listLoading: false, //显示加载中状态
      //弹窗--------------
      windowAdd: { //弹窗
        show: false,
        loading: false,
        index: 0,
        windowsParams: {},
      },
      windowAddItem: { //弹窗数据绑定
        id: 0,
        pic: '',
        setting_activity_apply_condition_id: '',
        is_guoqi: '',
        see_level: {},
        is_can_apply: '0',
        is_can_infinite_apply: '1',
        activity_type_id: '0'
      },
      windowAddValidate: {//窗口校验规则
      },                            //----------------
    }
  },
  created () {
    let vm = this
    vm.getList()
    vm.hasRule('activityManage/activityConfig/edit').then(res => {
      vm.buttonShow.edit = res
    })
    vm.hasRule('activityManage/activityConfig/del').then(res => {
      vm.buttonShow.del = res
    })
    vm.hasRule('activityManage/activityConfig/changeStatus').then(res => {
      vm.buttonShow.changeStatus = res
    })
  },
  mounted () {
    this.initializeEditor()
    this.getWindowsParams()
  },
  methods: {
    getWindowsParams () {
      getWindowsParams().then(response => {
        this.windowAdd.windowsParams = response.data.data
      })
      // vm.windowAddItem.see_level=params.row.see_level.split(',').map(Number);
    },
    initializeEditor () {
      this.editorObj1 = CKEDITOR.replace('ckeditor', {
        language: 'zh-CN',      // Adding drag and drop image upload.
        removeDialogTabs: 'image:advanced;image:Link',
        image_previewText: '  ',
        extraPlugins: 'uploadimage',
        uploadUrl: this.uploadUrlCk,
        filebrowserImageUploadUrl: this.uploadUrlCk,
        filebrowserUploadUrl: this.uploadUrlCk, //服务器上传地址
        removeButtons: 'Save,PasteFromWord,PasteText,Paste,Copy,Replace,Scayt,Checkbox,Radio,TextField,Textarea,Select,Button,ImageButton,HiddenField,BulletedList,NumberedList,Indent,Outdent,Language,About,ShowBlocks,Flash,Anchor,HorizontalRule,PageBreak,Iframe'
      })

      // 图片上传返回的数据处理
      this.editorObj1.on('fileUploadResponse', function (evt) {
        evt.stop()
        var data = evt.data
        let xhr = data.fileLoader.xhr
        let response = xhr.responseText
        let imgUrl = JSON.parse(response).data.fileUrl
        if (!imgUrl) {
          data.message = '上传出错'   // 这是失败alert提示信息
          evt.cancel()
        } else {
          data.url = imgUrl   // 返回到“图像信息”那里的URL框里面
        }
      })
    },
    preAdd () {
      let vm = this
      vm.windowAddItem = {}
      vm.windowAddItem.id = 0
      vm.windowAddItem.sort = 10
      vm.windowAddItem.is_lock = '0'
      vm.windowAddItem.activity_type_id = '0'
      vm.windowAddItem.see_level = []
      for (var key in vm.windowAdd.windowsParams.levelArray) {
        var id = vm.windowAdd.windowsParams.levelArray[key]['level_number']
        if (id != 0) {//0是黑名单
          vm.windowAddItem.see_level.push(id)
        }
      }
      vm.windowAddItem.is_guoqi = '0'
      vm.windowAddItem.is_can_apply = '0'
      vm.windowAddItem.is_can_infinite_apply = '1'
      vm.windowAddItem.setting_activity_apply_condition_id = '0'
      vm.windowAdd.show = true
    },
    changePage (page) {
      this.tableShow.currentPage = page
      this.getList()
    },
    changeSize (size) {
      this.tableShow.pageSize = size
      this.getList()
    },
    search () {
      this.tableShow.currentPage = 1
      this.getList()
    },
    getList () {
      let vm = this
      vm.listLoading = true
      getList({
        page: vm.tableShow.currentPage,
        size: vm.tableShow.pageSize,
        search: vm.searchConf
      }).then(response => {
        vm.tableData = response.data.data.list
        vm.tableShow.listCount = response.data.data.count
        vm.listLoading = false
      })
    },

    timeChange (datetimerange) { //时间修改，自动计算尾部时间
      if (datetimerange[0] !== '' && datetimerange[1] !== '') {
        let patt = /00:00:00/
        this.windowAddItem.start_time = datetimerange[0]
        this.windowAddItem.end_time = datetimerange[1]
        if (patt.test(datetimerange[1])) {
          datetimerange[1] = datetimerange[1].replace('00:00:00', '23:59:59')
          this.windowAddItem.start_time = datetimerange[0]
          this.windowAddItem.end_time = datetimerange[1]
        }
      } else {
        this.windowAddItem.start_time = ''
        this.windowAddItem.end_time = ''
      }
    },
    sortChange: function ({ column, key, order }) {
      //order值可能为asc,desc,normal
      this.searchConf.order = [key, order]
      if (order == 'normal') {
        this.searchConf.order = []
      }
      this.getList()
    },
    windowAddCancel (data) {
      if (!data) {
        this.windowAddItem.id = 0
        this.$refs['windowAddForm'].resetFields()
        this.windowAdd.show = false
        this.windowAdd.loading = false
        this.windowAdd.index = 0
      }
    }, windowAddSubmit () {
      let vm = this
      vm.$refs['windowAddForm'].validate((valid) => {
        if (valid) {
          vm.windowAdd.loading = true
          this.windowAddItem.body = this.editorObj1.getData()
          this.windowAddItem.see_level = this.windowAddItem.see_level.toLocaleString()
          if (Object.values(this.windowAddItem.start_time).length > 0 && Object.values(this.windowAddItem.end_time).length > 0) {
            var startDate = new Date((this.windowAddItem.start_time + ' 00:00:00').replace(/-/g, '/')) //传入一个时间格式，如果不传入就是获取现在的时间了，这样做不兼容火狐。
            var endDate = new Date((this.windowAddItem.end_time + ' 23:59:59').replace(/-/g, '/'))
            this.windowAddItem.start_time = startDate.getTime() / 1000
            this.windowAddItem.end_time = endDate.getTime() / 1000
          }
          add(vm.windowAddItem).then(response => {
            vm.$Message.success(response.data.msg)
            vm.getList()
            vm.windowAddCancel()
          }).catch(() => {
            vm.windowAdd.loading = false
          })
        }
      })
    },
    handleImgFormatError (file) {
      this.$Notice.warning({
        title: '文件类型不合法',
        desc: file.name + '的文件类型不正确，请上传jpg或者png图片。'
      })
    },
    handleImgRemove (key) {
      this.windowAddItem[key] = ''
    },
    handleImgSuccess (response) {
      if (response.code === 1) {
        this.$Message.success(response.msg)
        this.windowAddItem.pic = response.data.fileUrl
        //由于字段是动态的，所以查找一下 图片字段，再显示
        // for (let key in this.windowAdd.windowsParams2) {
        //   if (this.windowAdd.windowsParams2[key]['type'] == 'image') {
        //     this.windowAddItem[key] = response.data.fileUrl
        //   }
        // }
      } else {
        this.$Message.error(response.msg)
      }
    },
    handleImgMaxSize (file) {
      this.$Notice.warning({
        title: '文件大小不合法',
        desc: file.name + '太大啦请上传小于5M的文件。'
      })
    },
  }
}
</script>
